import { IconType } from "react-icons";

type StatCardProps = {
  icon: IconType;
  title: string;
  value: number;
  subtitle?: string;
  change?: string;
  changeColor?: string;
  highlight?: boolean;
};

export const StatCard: React.FC<StatCardProps> = ({
  icon: Icon,
  title,
  value,
  subtitle,
  change,
  changeColor = "text-green-600",
  highlight = false,
}) => (
  <div className={`p-6 rounded-lg border transition-all duration-200 ${
    highlight 
      ? 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-300 shadow-lg' 
      : 'bg-white border-gray-200'
  }`}>
    <div className="flex items-center justify-between mb-2">
      <Icon className="w-5 h-5 text-gray-600" />
    </div>
    <div className="text-2xl font-bold text-gray-900 mb-1">{value}</div>
    <div className="text-sm text-gray-600 mb-2">{title}</div>
    {change && <div className={`text-xs ${changeColor}`}>{change}</div>}
    {subtitle && <div className="text-xs text-gray-500">{subtitle}</div>}
  </div>
);
